import React, { FunctionComponent } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import FilterListSharpIcon from '@mui/icons-material/FilterListSharp';
import DownloadIcon from '@mui/icons-material/GetAppSharp';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAddSharp';
import Refresh from '@mui/icons-material/RotateLeft';
import { Box, Button, Paper, SxProps, Theme } from '@mui/material';

import { startCreatingJob } from '../../actions/jobActions';
import { isActiveViewFiltered } from '../../selectors/isActiveViewFiltered';
import { deselectAllJobs, setActiveControl } from '../../store/jobsSlice';
import { setViewToNoFilter } from '../../store/viewsSlice';
import { useAppDispatch, useAppSelector } from '../hooks';

interface ToggleButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  label: string;
  sx?: SxProps<Theme>;
  endIcon?: any;
}

const ToggleButton: FunctionComponent<ToggleButtonProps> = (props) => (
  <Button sx={props.sx} onClick={props.onClick} size="small" variant="contained" endIcon={props.endIcon}>
    {props.label}
  </Button>
);

interface Props {
  onShowDownloadGridPopup: () => void;
}

export function ControlBar(props: Props) {
  const { onShowDownloadGridPopup } = props;
  const dispatch = useAppDispatch();
  const activeControl = useAppSelector((state) => state.jobs.activeControl);
  const activeViewFiltered = useAppSelector(isActiveViewFiltered);

  const leftButton =
    activeControl === null ? (
      <ToggleButton
        sx={{ m: 1, width: 200 }}
        onClick={() => dispatch(startCreatingJob())}
        label="Create Job"
        endIcon={<PlaylistAddIcon />}
      />
    ) : (
      <ToggleButton
        sx={{ m: 1, width: 200 }}
        onClick={() => dispatch(setActiveControl(null))}
        label="Close"
        endIcon={<CloseIcon />}
      />
    );

  const resetButton =
    activeControl === 'manageJobs' ? (
      <ToggleButton
        sx={{ m: 1, width: 200 }}
        onClick={() => dispatch(deselectAllJobs())}
        label="Deselect Jobs"
        endIcon={<Refresh />}
      />
    ) : activeViewFiltered ? (
      <ToggleButton
        sx={{ m: 1, width: 200 }}
        onClick={() => dispatch(setViewToNoFilter())}
        label="Reset View"
        endIcon={<Refresh />}
      />
    ) : null;

  return (
    <Paper sx={{ display: 'flex', flexWrap: 'wrap', m: 2, bgcolor: 'backContrast.main' }}>
      {leftButton}
      <ToggleButton
        sx={{ m: 1, width: 200 }}
        onClick={() => dispatch(setActiveControl('views'))}
        label="Customize View"
        endIcon={<FilterListSharpIcon />}
      />
      {resetButton}
      <Box component="span" sx={{ mr: 'auto' }} />
      <Button
        variant="contained"
        endIcon={<DownloadIcon />}
        sx={{ m: 1, width: 200 }}
        onClick={onShowDownloadGridPopup}
      >
        Multi-Merge
      </Button>
    </Paper>
  );
}
